import { useEffect, useState } from 'react';
import { liveQuery } from 'dexie';
import { db } from '../db';
import { MUTATION_STATUS } from '../services/mutationLog';

const MIN_ATTEMPTS = 5;

export function useFailedMutations() {
  const [mutations, setMutations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const sub = liveQuery(() =>
      db.table('mutation_log')
        .where('status').equals(MUTATION_STATUS.FAILED)
        .sortBy('created_at'),
    ).subscribe({
      next: (rows) => {
        setMutations(rows.filter(r => (r.attempts ?? 0) >= MIN_ATTEMPTS));
        setIsLoading(false);
      },
      error: () => {
        setMutations([]);
        setIsLoading(false);
      },
    });
    return () => sub.unsubscribe();
  }, []);

  return { mutations, isLoading };
}

export default useFailedMutations;
